import React, { useState, useEffect } from "react";
import { Modal, Box, Typography } from "@mui/material";
import {
  Table,
  TableHeader,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
} from "@windmill/react-ui";
import AgentsServices from "services/AgentsServices";

const StatusModal = ({ isOpen, onClose, selectedData }) => {
  const [remarksData, setRemarksData] = useState();

useEffect(() => {
  if (!isOpen || !selectedData?.id) return;
    const fetchAgentById = async () => {
    try {
      const res = await AgentsServices.getRemarksById(selectedData.id);
      if (res.status) {
        setRemarksData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  fetchAgentById();
  return () => {
    setRemarksData(undefined);
  };
}, [isOpen, selectedData?.id]);



  return (
    <div>
      {/* Main Modal */}
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            padding: "20px",
            maxWidth: 900,
            width: "100%",
            borderRadius: "8px",
          }}
        >
          {/* Modal Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" id="modal-title">
              Remarks
            </Typography>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-800 transition duration-200"
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "1.2rem",
              }}
              aria-label="Close"
            >
              ✕
            </button>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {remarksData?.length > 0 ? (
              <TableContainer
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader>
                    <tr>
                      <TableCell className="text-center">
                        <b>Date</b>
                      </TableCell>
                      <TableCell className="text-center">
                        <b>User</b>
                      </TableCell>
                      <TableCell className="text-center">
                        <b>Status</b>
                      </TableCell>
                      <TableCell className="text-center">
                        <b>Reason</b>
                      </TableCell>
                    </tr>
                  </TableHeader>

                  <TableBody style={{ fontSize: "14px" }}>
                    {remarksData?.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell
                          className="text-center"
                          style={{ width: "50px !important" }}
                        >
                          {row.created_date?.split(" ")[0]}
                        </TableCell>
                        <TableCell className="text-center">
                          {row.action_by_emp}
                        </TableCell>
                        <TableCell className="text-center">
                          {row.action}
                        </TableCell>
                        <TableCell
                          className="text-center"
                          style={{
                            maxWidth: "250px",
                            width: "100%",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {row.remarks || "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No remarks available
              </Typography>
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default React.memo(StatusModal);
